
<div class="language">
  <div class="modal language-modal">
    <div class="modal-background" @click="closeModal"></div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="closeModal"
    ></button>
    <div class="modal-card">
      <section class="modal-card-body">
        <p class="title">{{ $t("choose-language") }}</p>
        <div class="wrapper">
          <div class="columns is-mobile">
            <div class="column" @click="changeLang('th')">
              <p><button class="button is-primary">TH</button></p>
              <p>ภาษาไทย</p>
            </div>
            <div class="column" @click="changeLang('en')">
              <p><button class="button is-primary">EN</button></p>
              <p>English</p>
            </div>
            <div class="column" @click="changeLang('ja')">
              <p><button class="button is-primary">JA</button></p>
              <p>日本語</p>
            </div>
          </div>
          <!-- <div class="columns is-mobile">
            <div class="column" @click="changeLang('zh')">
              <p>汉语</p>
            </div>
            <div class="column" @click="changeLang('my')">
              <p>မြန်မာစာ</p>
            </div>
            <div class="column" @click="changeLang('km')">
              <p>ភាសាខ្មែរ</p>
            </div>
          </div> -->
        </div>
      </section>
    </div>
  </div>
</div>
